import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { useData } from '../contexts/DataContext';

const Breadcrumbs = () => {
  const location = useLocation();
  const { state } = useData();
  
  const pathParts = location.pathname.split('/').filter(Boolean);
  
  const buildBreadcrumbs = () => {
    const crumbs = [
      { name: 'Inicio', path: '/', icon: Home }
    ];
    
    // Si es una ruta de admin
    if (pathParts[0] === 'admin') {
      crumbs.push({ name: 'Administración', path: '/pipelines' });
      
      const adminRoutes = {
        'settings': 'Configuración General',
        'email': 'Configuración Email',
        'ai-integration': 'Integración IA',
        'api-docs': 'API Docs',
      };
      
      if (pathParts[1] && adminRoutes[pathParts[1]]) {
        crumbs.push({ name: adminRoutes[pathParts[1]], path: null });
      }
      return crumbs;
    }
    
    // Rutas de embudo (kanban o pipeline)
    if (pathParts[0] === 'kanban' || pathParts[0] === 'pipeline') {
      // "Embudos" siempre lleva a Gestión Embudos
      crumbs.push({ name: 'Embudos', path: '/pipelines' });
      
      // Nombre del pipeline
      if (pathParts[1]) {
        const pipeline = state.pipelines.find(p => p.id === pathParts[1]);
        if (pipeline) {
          crumbs.push({ name: pipeline.name, path: null });
        }
      }
      return crumbs;
    }
    
    // Ruta de lead
    if (pathParts[0] === 'lead') {
      crumbs.push({ name: 'Todos los Leads', path: '/leads' });
      crumbs.push({ name: 'Detalle', path: null });
      return crumbs;
    }
    
    // Otras rutas simples
    const simpleRoutes = {
      'leads': 'Todos los Leads',
      'pipelines': 'Gestión Embudos',
      'form-builder': 'Constructor de Formularios',
      'notifications': 'Notificaciones',
    };
    
    if (pathParts[0] && simpleRoutes[pathParts[0]]) {
      crumbs.push({ name: simpleRoutes[pathParts[0]], path: null });
    }
    
    return crumbs;
  };

  const breadcrumbs = buildBreadcrumbs();

  // Dashboard - solo mostrar título
  if (breadcrumbs.length <= 1 && location.pathname === '/') {
    return (
      <div className="flex items-center text-sm">
        <span className="text-slate-900 font-medium">Dashboard</span>
      </div>
    );
  }

  return (
    <nav className="flex items-center text-sm" aria-label="Breadcrumb">
      <ol className="flex items-center gap-1">
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          const Icon = crumb.icon;
          
          return (
            <li key={`${crumb.name}-${index}`} className="flex items-center">
              {index > 0 && (
                <ChevronRight className="w-4 h-4 text-slate-400 mx-1" />
              )}
              
              {isLast || !crumb.path ? (
                <span className="text-slate-900 font-medium flex items-center gap-1">
                  {Icon && <Icon className="w-4 h-4" />}
                  {crumb.name}
                </span>
              ) : (
                <Link
                  to={crumb.path}
                  className="text-slate-500 hover:text-indigo-600 transition-colors flex items-center gap-1"
                >
                  {Icon && <Icon className="w-4 h-4" />}
                  {crumb.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
